import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";
import { PersonalNestApi } from "../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../providers/global-service/global-service";
import { CompanyGroupSf6Api } from "../../../shared/nestjs/gd-integrated/services/company-group-sf6.api";

@Injectable()
export class ProfileCompanygroupBloc {

	constructor(
		public personalApi: PersonalNestApi,    
		public globalService: GlobalServiceProvider,
		public nestResponse: NestResponsesProvider,	
		public companyGroupSf6Api: CompanyGroupSf6Api	
	) { }

	detail(payload): Observable<any> {
		console.log('BLOC | detail')
		return this.companyGroupSf6Api.detail(payload.empId);
	}

	save(data): Observable<any> {
		console.log('BLOC | save', data)    
		return this.companyGroupSf6Api.save(data);
	}

	getPersonal(payload): Promise<any> {
		return new Promise((resolve, reject) => {
			this.personalApi.getPersonal(payload).subscribe(
			async (result) => {
				console.log('BLOC | getPersonal', result)
				let resultData = await this.globalService.convertObjToCamelCase(result.data);
				resolve(resultData);
			}, error => {
				reject(error);
				console.log('getPersonal', error)
			}
			)
		})
	}
}



// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-companygroup.bloc.ts